const getGenreOptions = i18n =>
  [
    {
      id: 1,
      name: i18n.getString(_TL_('Horror')),
    },
    {
      id: 2,
      name: i18n.getString(_TL_('Crime')),
    },
    {
      id: 3,
      name: i18n.getString(_TL_('Game-show')),
    },
    {
      id: 4,
      name: i18n.getString(_TL_('Documentary')),
    },
    {
      id: 5,
      name: i18n.getString(_TL_('Romance')),
    },
    {
      id: 6,
      name: i18n.getString(_TL_('Sports - Other')),
    },
    {
      id: 7,
      name: i18n.getString(_TL_('Talk')),
    },
    {
      id: 8,
      name: i18n.getString(_TL_('Drama')),
    },
    {
      id: 9,
      name: i18n.getString(_TL_('Fantasy')),
    },
    {
      id: 10,
      name: i18n.getString(_TL_('Music')),
    },
    {
      id: 11,
      name: i18n.getString(_TL_('Shopping')),
    },
    {
      id: 12,
      name: i18n.getString(_TL_('Other')),
    },
    {
      id: 13,
      name: i18n.getString(_TL_('Action')),
    },
    {
      id: 14,
      name: i18n.getString(_TL_('Thriller')),
    },
    {
      id: 15,
      name: i18n.getString(_TL_('News')),
    },
    {
      id: 17,
      name: i18n.getString(_TL_('Reality')),
    },
    {
      id: 18,
      name: i18n.getString(_TL_('Comedy')),
    },
    {
      id: 19,
      name: i18n.getString(_TL_('Business & Finance')),
    },
    {
      id: 20,
      name: i18n.getString(_TL_('Cooking')),
    },
    {
      id: 21,
      name: i18n.getString(_TL_('Sitcom')),
    },
    {
      id: 22,
      name: i18n.getString(_TL_('Adventure')),
    },
    {
      id: 23,
      name: i18n.getString(_TL_('Sci-fi')),
    },
    {
      id: 25,
      name: i18n.getString(_TL_('Football')),
    },
    {
      id: 26,
      name: i18n.getString(_TL_('Animation')),
    },
    {
      id: 27,
      name: i18n.getString(_TL_('Baseball')),
    },
    {
      id: 28,
      name: i18n.getString(_TL_('Basketball')),
    },
    {
      id: 29,
      name: i18n.getString(_TL_('Biography')),
    },
    {
      id: 30,
      name: i18n.getString(_TL_('History')),
    },
    {
      id: 31,
      name: i18n.getString(_TL_('Musical')),
    },
    {
      id: 32,
      name: i18n.getString(_TL_('Mystery')),
    },
    {
      id: 33,
      name: i18n.getString(_TL_('Soccer')),
    },
    {
      id: 34,
      name: i18n.getString(_TL_('War')),
    },
    {
      id: 35,
      name: i18n.getString(_TL_('Western')),
    },
    {
      id: 36,
      name: i18n.getString(_TL_('Animals')),
    },
    {
      id: 37,
      name: i18n.getString(_TL_('Automotive')),
    },
    {
      id: 38,
      name: i18n.getString(_TL_('Science & Technology')),
    },
    {
      id: 39,
      name: i18n.getString(_TL_('Travel')),
    },
    {
      id: 40,
      name: i18n.getString(_TL_('Golf')),
    },
    {
      id: 41,
      name: i18n.getString(_TL_('Ice Hockey')),
    },
    {
      id: 42,
      name: i18n.getString(_TL_('Motor Sports')),
    },
    {
      id: 43,
      name: i18n.getString(_TL_('Beauty & Fashion')),
    },
    {
      id: 44,
      name: i18n.getString(_TL_('Home & Garden')),
    },
    {
      id: 45,
      name: i18n.getString(_TL_('Health')),
    },
    {
      id: 46,
      name: i18n.getString(_TL_('Fitness')),
    },
    // Children not allowed
    // {
    //     id: 47,
    //     name: i18n.getString(_TL_('Children')),
    // },
    {
      id: 48,
      name: i18n.getString(_TL_('Weather')),
    },
    {
      id: 49,
      name: i18n.getString(_TL_('Education')),
    },
    {
      id: 50,
      name: i18n.getString(_TL_('Cycling')),
    },
    {
      id: 51,
      name: i18n.getString(_TL_('Gaming')),
    },
    {
      id: 52,
      name: i18n.getString(_TL_('Rugby League')),
    },
    {
      id: 53,
      name: i18n.getString(_TL_('Rugby Union')),
    },
    {
      id: 54,
      name: i18n.getString(_TL_('Australian Rules Football')),
    },
    {
      id: 55,
      name: i18n.getString(_TL_('Tennis')),
    },
    {
      id: 56,
      name: i18n.getString(_TL_('Olympics')),
    },
    {
      id: 57,
      name: i18n.getString(_TL_('Softball')),
    },
    {
      id: 58,
      name: i18n.getString(_TL_('Cricket')),
    },
    {
      id: 59,
      name: i18n.getString(_TL_('MMA')),
    },
    {
      id: 60,
      name: i18n.getString(_TL_('Boxing')),
    },
    {
      id: 61,
      name: i18n.getString(_TL_('Horse Racing')),
    },
    // Religion and Politics not allowed
    // {
    //     id: 62,
    //     name: i18n.getString(_TL_('Politics')),
    // },
    // {
    //     id: 63,
    //     name: i18n.getString(_TL_('Religion')),
    // },
    {
      id: 64,
      name: i18n.getString(_TL_('Nature')),
    },
    {
      id: 65,
      name: i18n.getString(_TL_('Outdoors')),
    },
    {
      id: 66,
      name: i18n.getString(_TL_('Arts')),
    },
    {
      id: 67,
      name: i18n.getString(_TL_('Pop Culture')),
    },
    {
      id: 68,
      name: i18n.getString(_TL_('Fishing')),
    },
    {
      id: 69,
      name: i18n.getString(_TL_('Surfing')),
    },
    {
      id: 70,
      name: i18n.getString(_TL_('Paranormal')),
    },
    {
      id: 71,
      name: i18n.getString(_TL_('Awards')),
    },
    {
      id: 72,
      name: i18n.getString(_TL_('Martial Arts')),
    },
    {
      id: 73,
      name: i18n.getString(_TL_('Hobbies')),
    },
    {
      id: 74,
      name: i18n.getString(_TL_('Dance')),
    },
    {
      id: 75,
      name: i18n.getString(_TL_('Law')),
    },
    {
      id: 76,
      name: i18n.getString(_TL_('Comic Book')),
    },
    {
      id: 77,
      name: i18n.getString(_TL_('Holidays')),
    },
    {
      id: 78,
      name: i18n.getString(_TL_('Wrestling')),
    },
    // {
    //   id: 79,
    //   name: i18n.getString(_TL_('Gambling')),
    // },
    {
      id: 80,
      name: i18n.getString(_TL_('Anime')),
    },
    {
      id: 81,
      name: i18n.getString(_TL_('Soap-Opera')),
    },
  ];

const getDealGenreOptions = i18n =>
  [
    {
      id: 1,
      name: i18n.getString(_TL_('Horror')),
    },
    {
      id: 4,
      name: i18n.getString(_TL_('Documentary')),
    },
    {
      id: 5,
      name: i18n.getString(_TL_('Romance')),
    },
    {
      id: 8,
      name: i18n.getString(_TL_('Drama')),
    },
    {
      id: 9,
      name: i18n.getString(_TL_('Fantasy')),
    },
    {
      id: 13,
      name: i18n.getString(_TL_('Action')),
    },
    {
      id: 18,
      name: i18n.getString(_TL_('Comedy')),
    },
  ];

export { getGenreOptions, getDealGenreOptions };
